import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Box, Button, Typography } from "@mui/material";

function FileUploadMulti({ onFileAccepted, trigger }) {
  const [error, setError] = useState("");
  const [borderColor, setBorderColor] = useState("#ccc");
  const MAX_SIZE = 10 * 1024 * 1024; // 10 MB

  // Function to validate file type and content
  const validateFile = (file) => {
    return new Promise((resolve, reject) => {
      if (file.size > MAX_SIZE) {
        reject("Il file supera la dimensione massima di 10 MB.");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = (e) => {
        const arr = new Uint8Array(e.target.result).subarray(0, 4);
        const header = Array.from(arr).map(b => b.toString(16).toUpperCase().padStart(2, '0')).join("");
        
        // PDF: %PDF -> 25 50 44 46
        if (header === "25504446") {
          resolve(true);
          return;
        }
        
        // PNG: 89 50 4E 47
        if (header === "89504E47") {
          resolve(true);
          return;
        }

        // JPEG: FF D8 FF
        if (header.startsWith("FFD8FF")) {
          resolve(true);
          return;
        }

        reject("Formato file non supportato. Carica un PDF, JPEG o PNG.");
      };
      reader.onerror = () => reject("Errore nella lettura del file.");
      reader.readAsArrayBuffer(file.slice(0, 4));
    });
  };

  const onDropAccepted = useCallback(
    async (acceptedFiles) => {
      const file = acceptedFiles[0];

      if (!file) {
        setError("Nessun file selezionato.");
        setBorderColor("red");
        return;
      }

      try {
        await validateFile(file);
        setError("");
        setBorderColor("#ccc");
        onFileAccepted(acceptedFiles); // Pass the valid file to the parent
      } catch (errMsg) {
        setError(errMsg);
        setBorderColor("red");
      }
    },
    [onFileAccepted]
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    onDropAccepted,
    onDropRejected: () => {
      setError("Il file deve essere in formato PDF, JPEG o PNG e max 10 MB.");
      setBorderColor("red");
    },
    accept: {
      "application/pdf": [".pdf"],
      "image/jpeg": [".jpg", ".jpeg"],
      "image/png": [".png"]
    },
    maxSize: MAX_SIZE,
    noClick: true,
    noKeyboard: true,
  });

  return (
    <Box>
      <input {...getInputProps()} />
      {trigger ? (
        trigger({ open })
      ) : (
        <Box
          {...getRootProps()}
          sx={{
            border: `2px dashed ${borderColor}`,
            padding: "20px",
            textAlign: "center",
            cursor: "pointer",
            borderRadius: "4px",
          }}
        >
          <Typography variant="h6">Trascina qui un file (PDF, JPEG, PNG)</Typography>
          <Typography variant="body2" my={4}>
            Oppure
          </Typography>
          <Button variant="outlined" onClick={open}>
            Seleziona un file
          </Button>
        </Box>
      )}
      {error && (
        <Typography variant="body2" color="error" sx={{ marginTop: "10px" }}>
          {error}
        </Typography>
      )}
    </Box>
  );
}

export default FileUploadMulti;
